module.exports = __webpack_public_path__ + "img/private02.d26eb4e8.png";